import { render, staticRenderFns } from "./onlineProducts.vue?vue&type=template&id=1b40ec0c&scoped=true"
import script from "./onlineProducts.vue?vue&type=script&lang=js"
export * from "./onlineProducts.vue?vue&type=script&lang=js"
import style0 from "./onlineProducts.vue?vue&type=style&index=0&id=1b40ec0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40ec0c",
  null
  
)

export default component.exports